export class CashPayment {
  public InvoiceId: number;
  public InvoiceNumber: string;
  public Amount: number;
  public ReceiptNumber: string;
  public EmailReceiptToClient: boolean;
  public CustomerId: number;
  public PaymentType: number;
  public CustomerName: string;
  public CustomerAddress: string;
  public CustomerEmail: string;
  public BusinessName: string;
  public BusinessLogo: string;
  public BusinessAddress: string;
  public CreatedBy: number;
  public LocationId: number;

  public CashPayment() {
    this.EmailReceiptToClient = true;
    this.Amount = 0;
  }
}

export class VirtualSellCashPayment {
  public InvoiceNumber: string;
  public SourceComponent: number;
  public AmountPaid: number;
  public CreatedBy: number = 0;
  public LocationId: number;
  public CustomerId: number;
}

export class ReceiptDetails {
  public InvoiceNumber: string;
  public PaymentType: string;
}

export class SendReceipt {
  public InvoiceNumber: string;
  public ReceiptNumber: string;
  public StoreName: string;
  public StoreAddress: string;
  public PaymentMode: string;
  public AmountPaid: number;
  public Change: number;
  public From: string;
  public To: string;
  public MobileTo: string;
  public CommunicationType: CommunicationType;
  public Invoice: Invoice;
  public BranchName: string;
  public TransactionId: string;
}

export class NewSendReceipt {
  public emailAddress: string;
  public mobileNumber: string;
  public paymentMethod: string;
  public receiptNumber: string;
}

export class OrderItems {
  public ItemName: string;
  public UnitPrice: number;
  public LineTotal: number;
  public Quantity: string;
}

export class OrderAdjustments {
  public AdjustmentName: string;
  public Amount: number;
}

export class Invoice {
  public OrderSubTotal: number;
  public OrderTotal: number;
  public InvoiceDate: string;
  public OrderItems: OrderItems[];
  public OrderAdjustments: OrderAdjustments[];
  public InvoiceNumber: string;
}

export enum CommunicationType {
  Email = 0,
  Sms = 1,
}
